import { doc } from "firebase/firestore"
import { useDocumentData } from "react-firebase-hooks/firestore"
import { db } from "../firebase/firebase"
import { Avatar } from "@mui/material";
import CachedAvatar from "./CachedAvatar";

const ClickableAvatar = ({ id, key, ...props }) => {
    const [user, loading, error] = useDocumentData(doc(db, 'users', id));
    if (loading) return (<Avatar alt="..." title="..." />)
    if (error || user === undefined) return (<div>bad id</div>)

    return <CachedAvatar alt={user.title} src={user.image} title={user.title} key={key} {...props} />
}

export default ClickableAvatar;
